import JoinTeam from './JoinTeam';

export default JoinTeam;
